module.exports = __webpack_public_path__ + "img/dublab_default_file.80cf8e13.png";